/*
 * Export component file to be used on project
*/

import SearchPlaceholder from './SearchPlaceholder.js';
export default SearchPlaceholder;